import React from 'react';
import { Box } from '@quintoandar-tokko/jopijs';
import styles from './pendingReservationCard.module.scss';
import PropertyData from '../../PendingEvents/PropertyData';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import { getRemainingDays } from '../../utils';
import Trans from '@/components/shared/Trans';
import translations from '../../../Dashboard.trans.json';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function PendingReservationCard({ reservation, trackCallback }) {
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const {
    hours_until_expiry,
    property_picture_url,
    address,
    location,
    expiry_time,
  } = reservation;

  const remainingDays = getRemainingDays(expiry_time);

  const todayTime = Trans(translations, 'Today');
  const daysTime = `${remainingDays} ${Trans(
    translations,
    remainingDays === 1 ? 'day' : 'days'
  )}`;

  const displayTime = hours_until_expiry < 24 ? todayTime : daysTime;

  const propertyFileRedirect = () => {
    window.open(`${tokkoHost}/property/${reservation.id}`, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box
      onClick={propertyFileRedirect}
      className={styles.pendingReservationCard}
    >
      <PropertyData
        picture={property_picture_url}
        address={address}
        location={location}
      />
      <TimeStatusIndicator
        displayTime={displayTime}
        mode="remaining"
        value={hours_until_expiry}
        threshold={24}
        toolTipText={Trans(translations, 'ExpireIn')}
      />
    </Box>
  );
}

export default PendingReservationCard;
